<template>
  <div class="error-message-container">
    <content class="flex-centerered-content">
      <div class="title">
        <slot name="title">
          Out-of-date data
        </slot>
      </div>
      <div class="sub-title">
        <slot name="sub-title">
          Last refreshed 34 days ago
        </slot>
      </div>
    </content>

    <div class="controls flex-centerered-content">
      <button-input
        red
        @click.native="onClickButton"
      >
        <slot name="button-label">
          Refresh
        </slot>
      </button-input>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClickButton(ev) {
      this.$emit('click', ev);
    },
  },
};
</script>


<style lang="scss" scoped>
.error-message-container {
  margin: 10px;
  padding: 10px;
  background: $brightRed;
  border: 1px solid $mediumRed;
  border-radius: 6px;
  height: 72px;
  display: flex;

  flex-direction: row;
  color: $accentRed;

  .flex-centerered-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  content {
    flex: 1;
    align-items: flex-start;
    .title {
      @include h3;
    }
    .sub-title {
      @include text-tiny;
    }
  }

  .controls {
    flex: 1;
    align-items: flex-end;
  }
}
</style>

